import React from 'react'
// eslint-disable-next-line import/no-cycle
import Report from '../../Report/Report'
const FleetsReport = (props) => {
  const { fleet, onclose, drawer } = props
  return <Report value={fleet} fleetReport onclose={onclose} drawer={drawer} />
}
export default FleetsReport
